//@ts-check

export const sleep = (m) => new Promise((r) => setTimeout(r, m));

export async function getfetchopts(opts = {}) {
  const kyopts = {
    timeout: 30000,
    hooks: {
      beforeRequest: [
        (request) => {
          console.info(`Request: ${request.method} ${request.url}`);
          if (kyopts.json && !opts.noconsole) {
            console.info(JSON.stringify(kyopts.json, null, 2));
          }
        },
      ],
      beforeError: [
        async (error) => {
          if (error.response) {
            if (error.response.status == 401) {
              error.isautherr = true;
            }
            if (error.response.status == 403) {
              error.isauthzerr = true;
            }
            try {
              const responsebody = await error.response.json();
              error.body = responsebody;
              if (responsebody.message) {
                error.message = responsebody.message;
              }
            } catch (e) {
              console.error("Error while parsing error response");
            }
          }
          return error;
        },
      ],
      afterResponse: [
        (request, options, response) => {
          // CloudFront's SPA error pages (403/404 → /200.html, status 200) are distribution-wide, so
          // an API 403/404 comes back as 200 + the HTML app shell. Without this, callers do `.json()`
          // on HTML and get a cryptic "Unexpected token '<'". Detect that masked response and turn it
          // into a real, classified error (most often an expired session or missing permission).
          const ct = response.headers.get("content-type") || "";
          if (response.ok && ct.includes("text/html")) {
            const err = /** @type {any} */ (
              new Error(
                "Your session may have expired or you don't have permission for this action. Please sign in again."
              )
            );
            // Mirror the auth flags set in beforeError so callers can branch on it.
            err.isauthzerr = true;
            err.maskedError = true;
            throw err;
          }
        },
      ],
    },
    retry: 0,
  };

  if (opts) {
    Object.assign(kyopts, opts);
  }

  return kyopts;
}
